export default __webpack_public_path__ + "static/media/plus.b03e3495.svg";